<template>
  <div>
    <apexchart
      ref="chart"
      width="100%"
      height="240"
      type="rangeBar"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    range: {
      type: Array,
      required: true,
    },
  },
  computed: {
    options() {
      const [min, max] = this.range;

      return {
        chart: {
          id: 'timeline-chart',
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          type: 'datetime',
          ...(min ? { min: new Date(min).getTime() } : {}),
          ...(max ? { max: new Date(max).getTime() } : {}),
        },
        yaxis: {
          labels: {
            show: false,
            minWidth: 40,
            maxWidth: 40,
            formatter: (value, index) => {
              if (typeof index?.dataPointIndex === 'undefined') {
                return value;
              }
              return `Ad ${index.dataPointIndex + 1}`;
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
      };
    },
    series() {
      return [
        {
          data: this.data,
        },
      ];
    },
  },
  beforeDestroy() {
    this.$refs.chart.destroy();
  },
};
</script>
